import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lock\"><path d=\"M512.804571 73.142857a207.238095 207.238095 0 0 1 207.238096 207.238095l-0.024381 60.952381H828.952381a73.142857 73.142857 0 0 1 73.142857 73.142857v438.857143a73.142857 73.142857 0 0 1-73.142857 73.142857H195.047619a73.142857 73.142857 0 0 1-73.142857-73.142857V414.47619a73.142857 73.142857 0 0 1 73.142857-73.142857h110.494476v-60.952381a207.238095 207.238095 0 0 1 207.238095-207.238095z m42.764191 463.238095h-73.142857v195.047619h73.142857v-195.047619zM512.804571 146.285714a134.095238 134.095238 0 0 0-134.095238 134.095238V341.333333h268.190477v-60.952381a134.095238 134.095238 0 0 0-134.095239-134.095238z\" p-id=\"2946\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg/lock.svg
// module id = 50qg
// module chunks = 12